'use strict';

var React = require('react');

var SvgPriceListIcon = function SvgPriceListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 3a1.75 1.75 0 0 0-1.75 1.75v10.5c0 .966.784 1.75 1.75 1.75h4.5a.75.75 0 0 0 0-1.5h-4.5a.25.25 0 0 1-.25-.25v-10.5a.25.25 0 0 1 .25-.25h8a.25.25 0 0 1 .25.25v2.75a.75.75 0 0 0 1.5 0v-2.75a1.75 1.75 0 0 0-1.75-1.75h-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.25a.75.75 0 0 0-1.5 0v.25a2 2 0 1 0 0 4h1a.5.5 0 0 1 0 1h-2.25a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 1.5 0 2 2 0 1 0 0-4h-1a.5.5 0 0 1 0-1h2.25a.75.75 0 0 0 0-1.5h-.75v-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9a.75.75 0 0 0 0 1.5h2.75a.75.75 0 0 0 0-1.5h-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
  }));
};
SvgPriceListIcon.displayName = "PriceListIcon";

exports.SvgPriceListIcon = SvgPriceListIcon;
